import './Menu.scss';

import Close from "@mui/icons-material/Close";

import { DarkLogo } from "../common-components/Logo/Logo";
import { IconButton } from "../common-components/Buttons/Buttons";

import MenuNavigation from "./components/MenuNavigation/MenuNavigation";
import MenuFooter from "./components/MenuFooter/MenuFooter";

const Menu = ({onClose, isOpen}) => {

    return (
        <div className={`menu ${isOpen ? "--open" : ""}`}>
            <div className={"menu_container"}>
                <header className={"menu_header"}>
                    <div className={"menu_logo"}>
                        <DarkLogo width={"100"}/>
                    </div>
                    <div className={"menu_close"}>
                        <IconButton
                            Icon={Close}
                            onClick={onClose}
                        />
                    </div>
                </header>
                <nav className={"menu_main"}>
                    <MenuNavigation onClose={onClose}/>
                </nav>
                <footer className={"menu_footer"}>
                    <MenuFooter/>
                </footer>
            </div>
        </div>
    )
}

export default Menu;